










































































































import Vue, { PropType } from 'vue'
import { UserScheduledQuerySubscription } from '@/interfaces/scheduled-query'
import axios from 'axios'
import _ from 'lodash'
import { mapState } from 'vuex'

export default Vue.extend({
  model: {
    prop: 'visible',
    event: 'change'
  },

  props: {
    visible: Boolean,
    toModifyScheduledQuerySubscription: {
      type: Object as PropType<UserScheduledQuerySubscription>,
      default: () => {}
    }
  },

  data () {
    return {
      toModifySubscription: {
        scheduledId: -1,
        authorEmail: '',
        day: 1,
        hourAndMinute: '00:00',
        recurrence: 'Daily',
        notifySlack: false,
        notifyEmail: false,
        hasResults: false,
        types: [] as string[]
      }
    }
  },

  computed: {
    ...mapState('scheduledQuery', {
      minutes: 'minutes',
      hours: 'hours',
      daysOfWeek: 'daysOfWeek'
    })
  },

  watch: {
    toModifyScheduledQuerySubscription (value) {
      if (value === {}) {
        this.resetModifySubscriptionForm()
      } else {
        this.toModifySubscription = _.cloneDeep(value)
      }
    }
  },

  methods: {
    onModalVisibleChange (visible: Boolean) {
      this.$emit('change', visible)
    },

    /**
     * Validate modify scheduled query form. On successful validation, update the scheduled query.
     * Will convert local time input to UTC time for server.
     * @param {String} formName
     */
    async modifySubscription (): Promise<void> {
      // notifyBy stores the original subscription type-subId mapping, notifyEmail/Slack is the current setting
      const { notifyEmail, notifySlack, scheduledId, types } = this.toModifySubscription

      if (types.includes('email') === notifyEmail && types.includes('slack') === notifySlack) {
        this.closeModifyModal()
        return
      }

      try {
        await axios({
          method: 'put',
          url: `${process.env.VUE_APP_API_URI}/scheduled-queries/subscriptions`,
          data: {
            scheduledId,
            notifySlack,
            notifyEmail,
            userId: this.$auth.getUser().id
          }
        })
        this.closeModifyModal()
        this.$store.dispatch('scheduledQuery/onLoadScheduledQueriesSubscriptions', this.$auth.getUser().id)
        this.$store.dispatch('scheduledQuery/onLoadScheduledQueries', this.$auth.getUser().id)
      } catch (error) {
        this.$Message.error(`Error modifying scheduled query: ${error}`)
        console.error('Error modifying scheduled query: ', error)
        this.closeModifyModal()
      }
    },

    resetModifySubscriptionForm (): void {
      this.toModifySubscription = {
        scheduledId: -1,
        authorEmail: '',
        recurrence: 'Daily',
        day: new Date().getDay(),
        hourAndMinute: '00:00',
        hasResults: false,
        notifySlack: false,
        notifyEmail: false,
        types: []
      }
    },

    closeModifyModal () {
      this.$emit('close-modify-modal')
      this.resetModifySubscriptionForm()
    }
  }
})
